import { storage } from "@/lib/firebase";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

/**
 * Sube una imagen a Firebase Storage.
 * @param file El archivo a subir.
 * @returns Una promesa que resuelve con la URL pública y permanente de la imagen.
 */
export const uploadImage = async (file: File): Promise<string> => {
    if (!file.type.startsWith('image/')) {
        throw new Error("El archivo seleccionado no es una imagen.");
    }
    const uniqueFilename = `${Date.now()}-${file.name}`;
    const storageRef = ref(storage, `question-images/${uniqueFilename}`);

    await uploadBytes(storageRef, file);

    const downloadURL = await getDownloadURL(storageRef);

    return downloadURL;
};

/**
 * Elimina una imagen de Firebase Storage usando su URL de descarga.
 * @param imageUrl La URL pública de la imagen a eliminar.
 */
export const deleteImage = async (imageUrl: string | null | undefined): Promise<void> => {
    if (!imageUrl || !imageUrl.includes('firebasestorage.googleapis.com')) {
        return;
    }

    try {
        const imageRef = ref(storage, imageUrl);
        await deleteObject(imageRef);
    } catch (error: any) {
        if (error.code === 'storage/object-not-found') {
            console.warn("La imagen no se encontró en Firebase, pero se procederá a limpiar la URL.");
        } else {
            console.error("Error al eliminar la imagen de Firebase:", error);
            throw error;
        }
    }
};
